import { useMemo } from 'react';
import { ApprovalStepStatus } from 'ui-product-approvals-common';
import { ACTOR } from '../constants/actors';
export const getApprovalStepsInfo = (approvalSteps, currentUserId) => {
  const defaultValue = {
    stepCount: 0,
    pendingCount: 0,
    approvedCount: 0,
    stepStatusForCurrentActor: undefined
  };
  if (!approvalSteps.length) {
    return defaultValue;
  }
  return approvalSteps.reduce((accumulator, approvalStep) => {
    const {
      pendingCount,
      approvedCount,
      stepStatusForCurrentActor
    } = accumulator;
    const {
      approvalStepStatus,
      approver
    } = approvalStep;
    const isPending = approvalStepStatus === ApprovalStepStatus.APPROVAL_PENDING;
    const isApproved = approvalStepStatus === ApprovalStepStatus.APPROVED;
    // Not yet updated to support TEAM actors — only USER actors are matched
    // here. Agent actors aren't relevant here as they don't perform actions on the FE.
    const isCurrentUsersStep = approver.actor.actorType === ACTOR.USER && approver.actor.id === currentUserId;
    return {
      stepCount: approvalSteps.length,
      pendingCount: isPending ? pendingCount + 1 : pendingCount,
      approvedCount: isApproved ? approvedCount + 1 : approvedCount,
      stepStatusForCurrentActor: isCurrentUsersStep ? approvalStepStatus : stepStatusForCurrentActor
    };
  }, defaultValue);
};
export const useApprovalStepsInfo = (approvalSteps, currentUserId) => useMemo(() => getApprovalStepsInfo(approvalSteps, currentUserId), [approvalSteps, currentUserId]);